var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "min-height": "160px",
      "padding": "40px"
    }
  }, [_c('div', {
    staticClass: "pa-6"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "learnicsGreen",
      "size": "64"
    }
  })], 1), _c('div', [_vm._t("default")], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }